export const SWAP_VAULT_ABI = [
  {
    inputs: [
      { internalType: 'address', name: 'fromAsset', type: 'address' },
      { internalType: 'uint256', name: 'fromAmount', type: 'uint256' },
      { internalType: 'address', name: 'toAsset', type: 'address' },
      { internalType: 'address', name: 'toVault', type: 'address' },
      { internalType: 'uint256', name: 'minMintAmount', type: 'uint256' },
      { internalType: 'bytes', name: 'swapPath', type: 'bytes' },
      { internalType: 'bool', name: 'skipDeposit', type: 'bool' },
    ],
    name: 'deposit',
    outputs: [{ internalType: 'int256', name: 'finalGain', type: 'int256' }],
    stateMutability: 'payable',
    type: 'function',
  },
] as const
